import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text } from './atoms';
import { InputRemovableImage } from 'molecules';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${`${theme?.colour?.primary}0D`};
    padding: 8px 20px 8px 20px;
    text-align: center;
    border-radius: 8px;
  `}
`;

export default Molecule({
  template: template,
  atoms: [
    {
      component: Text,
      name: 'BoldText',
      displayValue: ({ boldText }) => boldText ?? '',
      displayState: ({ }) => ({ weight: 600 })
    },
    {
      component: InputRemovableImage,
      name: 'Image',
      renderIf: ({ img }) => !!img,
      bindings: ({ img }) => ({ url: img, popup: 'Click to see image', width: '176px', height: '250px' })
    },
    {
      component: Text,
      name: 'Text',
      displayValue: ({ text }) => text ?? '',
    }
  ]
});
